import * as React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const Cell = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    return (
      <div {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  constraints: {
    pinToParent: true,
    parent: [
      {
        is: 'Layout',
        rule: 'ExactlyOne',
      },
    ],
  },
  displayName: 'Cell',
  style: {
    base: {
      main: {
        noPseudo: {
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        },
      },
    },
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('Cell')),
  },
  lockedStyles: {
    marginLeft: {
      when: true,
      message: 'Cannot add margin to a Cell.',
    },
    marginRight: {
      when: true,
      message: 'Cannot add margin to a Cell.',
    },
    marginTop: {
      when: true,
      message: 'Cannot add margin to a Cell.',
    },
    marginBottom: {
      when: true,
      message: 'Cannot add margin to a Cell.',
    },
  },
  render: Cell,
  showEmpty: true,
  fields: {children: TListOfElement},
});

export default config;
